import React from 'react';
import { EnumChoicesTypeInfoFragment } from '../../generated.graphql';


interface YesNoLabelProps {
  value: boolean;
}

export const YesNoLabel = (props: YesNoLabelProps) => (<b>{props.value ? 'Yes' : 'No'}</b>);


export function getEnumDisplay(value?: string | null, _enum?: EnumChoicesTypeInfoFragment | null): string | null {
  const choice = _enum?.enumValues?.find(choice => choice.name === value);
  return choice?.description ?? value ?? null;
}


export function getTimePeriodDisplay(years?: number | null, months?: number | null) {
  return [
    years ? `${years} year${years !== 1 ? 's' : ''}` : '',
    months ? `${months} month${months !== 1 ? 's' : ''}` : ''
  ].join(' ').trim();
}